import { DEFAULT_TABLE_PAGESIZE } from 'components/Table/contants';
import { useHistory } from 'react-router-dom';

export const useRoutes = () => {
  const history = useHistory();

  const returnHome = () => {
    const pageIndex = new URLSearchParams(history.location.search).get('page');
    const pageSize = new URLSearchParams(history.location.search).get(
      'pagesize'
    );
    history.push(
      `/benchmarks?page=${pageIndex || 1}&pagesize=${
        pageSize || DEFAULT_TABLE_PAGESIZE
      }`
    );
  };

  return { returnHome };
};
